/**
 * AMC FAB stack — align theme FABs to the Tidio *launcher* (loads late).
 * Ignores the open chat panel so FABs don't jump off-screen.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var raf = 0;
  var debounceTimer = 0;
  var lastGoodTidio = null;
  var tidioHostObserver = null;
  var bootObserver = null;

  function stickyEl() {
    return document.querySelector('.sticky_book_wizard');
  }

  function stickyVisible() {
    if (!root.classList.contains('amc-sticky-book-on')) return false;
    var el = stickyEl();
    if (!el) return false;
    var style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function scrollFabVisible() {
    var wrap = document.querySelector('.scroll-to-top > [x-data]');
    if (!wrap) return false;
    return getComputedStyle(wrap).display !== 'none';
  }

  function isLauncherRect(r) {
    if (!r) return false;
    if (r.width < 36 || r.height < 36) return false;
    if (r.width > 360 || r.height > 140) return false;
    if (r.bottom < 0 || r.top > window.innerHeight) return false;
    if (r.right < 0 || r.left > window.innerWidth) return false;
    return true;
  }

  function tidioHost() {
    return document.getElementById('tidio-chat');
  }

  function tidioLauncherRect() {
    var host = tidioHost();
    if (!host) return lastGoodTidio;

    var nodes = [host];
    var iframes = host.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) nodes.push(iframes[i]);

    var best = null;
    var bestScore = Infinity;

    for (var n = 0; n < nodes.length; n++) {
      var r = nodes[n].getBoundingClientRect();
      if (!isLauncherRect(r)) continue;
      var dist =
        Math.abs(window.innerWidth - r.right) + Math.abs(window.innerHeight - r.bottom);
      var score = dist + r.width + r.height;
      if (score < bestScore) {
        bestScore = score;
        best = {
          top: r.top,
          bottom: r.bottom,
          left: r.left,
          right: r.right,
          width: r.width,
          height: r.height
        };
      }
    }

    if (best) {
      lastGoodTidio = best;
      return best;
    }
    return lastGoodTidio;
  }

  function measure() {
    var mobile = window.matchMedia('(max-width: 767.98px)').matches;
    var fabSize = mobile ? 64 : 56;
    var gap = 14;
    var floor = 20;
    var hasScrollFab = scrollFabVisible();
    var hasEnvelope = !!document.querySelector('.amc-envelope-teaser.is-visible');
    var vh = window.innerHeight;
    var vw = window.innerWidth;

    var stickyLift = 0;
    if (stickyVisible()) {
      var sRect = stickyEl().getBoundingClientRect();
      stickyLift = Math.max(0, Math.round(vh - sRect.top));
    }

    var tRect = tidioLauncherRect();
    var tidioBottom = floor;
    var fabRight = 16;
    var scrollBottom;
    var envelopeBottom;

    if (tRect) {
      tidioBottom = Math.max(0, Math.round(vh - tRect.bottom));
      fabRight = Math.max(8, Math.round(vw - tRect.right));
      scrollBottom = Math.max(0, Math.round(vh - tRect.top) + gap);
      root.classList.add('amc-tidio-ready');
    } else {
      tidioBottom = floor + (stickyLift ? stickyLift + gap : 0);
      fabRight = 16;
      scrollBottom = tidioBottom + (mobile ? 64 : 60) + gap;
      root.classList.remove('amc-tidio-ready');
    }

    if (stickyLift > 0 && !mobile) {
      var minFloor = stickyLift + gap;
      if (tidioBottom < minFloor) {
        var lift = minFloor - tidioBottom;
        tidioBottom += lift;
        scrollBottom += lift;
      }
    }

    envelopeBottom = hasScrollFab ? scrollBottom + fabSize + gap : scrollBottom;

    var mFabBottom = tidioBottom;
    if (mobile && stickyLift > 0) {
      mFabBottom = stickyLift + gap;
      scrollBottom = mFabBottom;
      envelopeBottom = mFabBottom;
      tidioBottom = mFabBottom;
    }

    var maxBottom = Math.max(floor, vh - fabSize - 8);
    scrollBottom = Math.min(scrollBottom, maxBottom);
    envelopeBottom = Math.min(envelopeBottom, maxBottom);
    if (hasScrollFab && envelopeBottom < scrollBottom + fabSize) {
      envelopeBottom = Math.min(scrollBottom + fabSize + gap, maxBottom);
    }

    root.style.setProperty('--amc-m-fab-size', fabSize + 'px');
    root.style.setProperty('--amc-fab-right', fabRight + 'px');
    root.style.setProperty('--amc-tidio-bottom', tidioBottom + 'px');
    root.style.setProperty('--amc-scroll-bottom', scrollBottom + 'px');
    root.style.setProperty('--amc-envelope-bottom', envelopeBottom + 'px');
    root.style.setProperty('--amc-m-fab-bottom', mFabBottom + 'px');
    root.style.setProperty('--amc-fab-sticky', stickyLift + 'px');
    root.classList.toggle('amc-fab-sticky', stickyLift > 0);
    root.classList.toggle('amc-fab-mobile', mobile);
    root.classList.toggle('amc-envelope-teaser-on', hasEnvelope);

    /* Only lift Tidio host while launcher-sized (never open chat panel). */
    var liftOk = false;
    if (mobile && stickyLift > 0) {
      var hostEl = tidioHost();
      if (hostEl) {
        var hr = hostEl.getBoundingClientRect();
        liftOk = isLauncherRect(hr);
      }
    }
    root.classList.toggle('amc-tidio-lift', liftOk);
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = 0;
      measure();
    });
  }

  function scheduleDebounced(ms) {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      debounceTimer = 0;
      schedule();
    }, ms || 120);
  }

  function observeTidioHost(host) {
    if (!host || !window.MutationObserver) return;
    if (tidioHostObserver) tidioHostObserver.disconnect();
    tidioHostObserver = new MutationObserver(function () {
      scheduleDebounced(160);
    });
    tidioHostObserver.observe(host, {
      childList: true,
      subtree: true
    });
  }

  function watchForTidio() {
    var existing = tidioHost();
    if (existing) {
      observeTidioHost(existing);
      return;
    }
    if (!window.MutationObserver || bootObserver) return;
    bootObserver = new MutationObserver(function () {
      var host = tidioHost();
      if (!host) return;
      if (bootObserver) {
        bootObserver.disconnect();
        bootObserver = null;
      }
      observeTidioHost(host);
      schedule();
      bindTidioApi();
    });
    bootObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function bindTidioApi() {
    try {
      if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') {
        if (!window.tidioChatApi.__amcFabBound) {
          window.tidioChatApi.__amcFabBound = true;
          window.tidioChatApi.on('ready', schedule);
          window.tidioChatApi.on('open', schedule);
          window.tidioChatApi.on('close', schedule);
        }
      }
    } catch (e) {}
  }

  function boot() {
    measure();
    watchForTidio();
    bindTidioApi();
    document.addEventListener('tidioChat-ready', function () {
      bindTidioApi();
      schedule();
    });

    window.addEventListener('resize', scheduleDebounced.bind(null, 100), { passive: true });
    /* Scroll only remasures when sticky class is active (bar height can change). */
    window.addEventListener(
      'scroll',
      function () {
        if (root.classList.contains('amc-sticky-book-on')) scheduleDebounced(100);
      },
      { passive: true }
    );

    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        scheduleDebounced(80);
      });
      mo.observe(root, { attributes: true, attributeFilter: ['class'] });
      var sticky = stickyEl();
      if (sticky) {
        mo.observe(sticky, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden']
        });
      }
      var teaser = document.querySelector('[data-amc-envelope-teaser]');
      if (teaser) {
        mo.observe(teaser, { attributes: true, attributeFilter: ['class', 'hidden'] });
      }
    }

    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    [500, 1500, 3500].forEach(function (ms) {
      window.setTimeout(function () {
        bindTidioApi();
        schedule();
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
